module.exports = "<div class=\"collection\">\n\n  {{roleUserClient.authUser.user.nom}} {{roleUserClient.authUser.user.prenom}}\n</div>\n\n"